import React, {useState} from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = ({ height, dates }) => {
  const series = [
    {
      name: "XYZ MOTORS",
      data: dates,
    },
  ];
  const options = {
    colors: ["#01CC8E"],
    stroke: {
      width: 2.5, // Set the line width to 2 pixels
    },
    chart: {
      type: "area",
      stacked: false,
      height: height || 97,
      pan: {
        enabled: false, // Disable zooming
      },
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false, // Hide the toolbar
      },

      marginLeft: 0, // Remove left margin
      marginRight: 0, // Remove right margin
      marginBottom: 0, // Remove bottom margin
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    title: {
      text: "",
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [10, 90, 100],
      },
      colors: ["#01CC8E"],
    },
    grid: {
      show: false,
      // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: false, //or just here to disable only x axis grids
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    yaxis: {
      labels: {
        show: false, // Hide the bottom label value
      },
      lines: {
        show: false, // Hide all the lines in the x-axis
      },
    },

    xaxis: {
      type: "datetime",
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      lines: {
        show: false, // Hide all the lines in the x-axis
        stroke: {
          colors: "transparent", // Set the line color to transparent
        },
      },

      show: false,
      labels: {
        show: false, // Hide the bottom label value
      },
    },
    tooltip: {
      enabled: false,
    },
    toolbar: {
      show: false, // Hide the toolbar
    },
    zoom: {
      enabled: false, // Disable zooming
    },
    interactivity: {
      enabled: false, // Disable interactivity including mouse drag events
    },
  };
  return (
    <div>
      <div
        id="chart"
        className="relative top-[-20px]"
        style={{
          minHeight: 0,
          height: "150px",
          marginLeft: "-20px",
          marginRight: "-10px",
          marginBottom: "10px",
        }}
      >
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={150}
        />
      </div>
    </div>
  );
};

export default LineChart;
